import { Box, Text } from "@chakra-ui/react";
import ScheduleSlot from "./ScheduleSlot";

export default function ScheduleRow({ id, rowNumber, session, subjects, time,degree,specification }) {
    return (
        <Box
      width='100%'
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      borderLeft='1px solid rgba(0,0,0,0.1)'
    >
      <Box
        flex='1'
        display='flex'
        height='100px'
        justifyContent='center'
        alignItems='center'
        color='#F25C3A'
        style={{ fontFamily: 'Mulish, sans-serif' }}
        

      >
        <Text
          fontStyle='normal'
          lineHeight='18px'
          fontSize='16px'
          fontWeight='700'
          color='#999999'
          style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
        >
         {`${time.split('-')[0]} - ${time.split('-')[1]}`}
        </Text>
      </Box>
            {
                session.map((slot, idx) => <ScheduleSlot sessionId = {rowNumber} slot={slot} slotId={idx} classId={id} key={idx} subjects={subjects} degree={degree} specification={specification} />)
            }
        </Box>
    )
}